import type { ActionReducerMap } from '@ngrx/store';
import { layoutReducer, type LayoutState } from './layout/layout-reducers';
import {
  calendarReducer,
  type CalendarState,
} from './calendar/calendar.reducer';

export interface RootReducerState {
  layout: LayoutState;
  Calendar: CalendarState;
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  layout: layoutReducer,
  Calendar: calendarReducer,
};
